<template>
    <div class="tickets-mobile-wrap">
        <div class="container">
            <filters
                :locations="locations"
                :dates="dates"
                :trans="trans"
                :price_range="price_range"
                :callback="filterCallback"
            >
            </filters>
        </div>

        <div class="container">
            <promocode
                v-if="allowPromocode"
                :submitCallBack="applyPromocode"
                :trans="trans"
            ></promocode>
        </div>

        <div class="container">
            <div class="alert alert-warning" v-if="ticketsList.length < 1">
                {{ trans.tickets["no-tickets"] }}
            </div>

            <div class="ticket-items">
                <ticket
                    v-for="(ticket, key) in ticketsList"
                    :key="key"
                    :ticket="ticket"
                    :outlet="true"
                    :config="config"
                    :icons="trans.tickets.table.icons"
                    :trans="trans"
                    :promotionalInfo="promotionalInfo"
                    :openModal="openModal"
                >
                </ticket>
            </div>

            <modal name="simple">
                <div slot="body" v-if="modal.type">
                    <div
                        v-if="modal.type === 'description'"
                        v-html="modal.content"
                    ></div>

                    <div v-if="modal.type === 'img'">
                        <div v-if="isCarousel">
                            <figure
                                @touchstart="handleTouchStart"
                                @touchmove.prevent="handleTouchMove"
                                @touchend="handleTouchEnd"
                            >
                                <img
                                    :src="modal.content[currentIndex]"
                                    alt=""
                                />
                            </figure>
                            <div class="buttons-mobile-carrossel">
                                <button
                                    class="button button-outline button-icon"
                                    @click="prevImage"
                                >
                                    <i class="fa fa-arrow-left"></i>
                                </button>
                                <button
                                    class="button button-outline button-icon"
                                    @click="nextImage"
                                >
                                    <i class="fa fa-arrow-right"></i>
                                </button>
                            </div>
                            <p class="swipe-hint">
                                {{ trans.tickets.table["text-carrossel"] }}
                            </p>
                        </div>

                        <div v-else>
                            <figure>
                                <img :src="modal.content[0]" alt="" />
                            </figure>
                        </div>
                    </div>

                    <div v-if="modal.type === 'map'">
                        <figure>
                            <img :src="modal.content" alt="Map Image" />
                        </figure>
                    </div>
                </div>
            </modal>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.alert {
    padding: 12px 10px;
    text-align: center;
    margin-bottom: 32px;
    background: var(--color-yellow-lighter);
    border: 2px solid var(--color-yellow-medium);
    font-size: 1rem;
    color: var(--color-yellow-dark);
}

.buttons-mobile-carrossel {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 87%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    pointer-events: none;
}

.buttons-mobile-carrossel button {
    width: 40px;
    height: 40px;
    pointer-events: auto;
    background: var(--color-purple-dark);
    color: var(--color-white);
    border: 1px solid var(--color-white);
    font-size: 18px;
    cursor: pointer;
}

.swipe-hint {
    text-align: center;
    font-size: 14px;
    color: var(--color-gray-dark);
    margin-top: 10px;
}

.ticket-items {
    margin-top: 32px;

    @media (min-width: 768px) {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .item {
            width: 48%;
        }
    }

    @media (min-width: 992px) {
        .item {
            width: 32%;
        }
    }
}
</style>

<script>
import Modal from "../modal/ModalWrapper.vue";
import Filters from "./MobileTicketsFilter.vue";
import Ticket from "./MobileTicketsItem.vue";
import Promocode from "./TicketsPromocode.vue";

export default {
    props: {
        offday: String,
        split: String,
        config: {
            type: Object,
            required: true
        },
        dates: {
            type: Array,
            required: true
        },
        locations: {
            type: Array,
            required: true
        },
        price_range: {
            type: Object,
            required: true
        },
        tickets: {
            type: Array,
            required: true
        },
        trans: {
            type: Object,
            required: true
        }
    },

    components: {
        Filters,
        Promocode,
        Ticket,
        Modal
    },

    mounted() {
        this.setLocationMatchesActive();

        const modalElement = document.querySelector(".modal-body");
        if (modalElement) {
            modalElement.addEventListener("touchstart", this.handleTouchStart, {
                passive: false
            });
            modalElement.addEventListener("touchmove", this.handleTouchMove, {
                passive: false
            });
            modalElement.addEventListener("touchend", this.handleTouchEnd, {
                passive: false
            });
        }
    },

    data() {
        return {
            ticketsList: this.unobserve(this.tickets),
            modal: {},
            promotionalInfo: null,
            currentIndex: 0,
            touchStartX: 0,
            touchEndX: 0,
            isCarousel: false
        };
    },

    computed: {
        isOutlet() {
            const priceType = this.config.price_type;
            return priceType.toLowerCase().includes("outlet");
        },

        allowPromocode() {
            const allow = this.config.allow_promocode;
            return allow && !this.isOutlet;
        }
    },

    methods: {
        applyPromocode(data) {
            if (!data) {
                this.promotionalInfo = null;
                return false;
            }
            this.promotionalInfo = data;
        },

        getDescriptionByTicket(ticket) {
            const match = this.locations.filter(
                location => location.slug === ticket.slug
            );
            return match.length < 1 ? "" : match[0].short_description;
        },

        handleTouchStart(event) {
            this.touchStartX = event.touches[0].clientX;
            this.touchEndX = this.touchStartX;
        },

        handleTouchMove(event) {
            this.touchEndX = event.touches[0].clientX;
        },

        handleTouchEnd() {
            const swipeDistance = this.touchStartX - this.touchEndX;

            if (Math.abs(swipeDistance) > 50) {
                if (swipeDistance > 0) {
                    this.nextImage();
                } else {
                    this.prevImage();
                }
            }
        },

        nextImage() {
            if (this.currentIndex < this.modal.content.length - 1) {
                this.currentIndex++;
            } else {
                this.currentIndex = 0;
            }
        },

        prevImage() {
            if (this.currentIndex > 0) {
                this.currentIndex--;
            } else {
                this.currentIndex = this.modal.content.length - 1;
            }
        },

        openModal(type, ticket) {
            switch (type) {
                case "map":
                    this.modal.content = ticket.map;
                    this.modal.type = "map";
                    break;
                case "img":
                    if (Array.isArray(ticket.imgs) && ticket.imgs.length > 0) {
                        this.modal.content = ticket.imgs;
                        this.isCarousel = true;
                    } else {
                        this.modal.content = [ticket.img];
                        this.isCarousel = false;
                    }
                    this.currentIndex = 0;
                    break;
                case "description":
                    this.modal.content = this.getDescriptionByTicket(ticket);
                    break;
                case "text":
                    this.modal.content = `
            <h2>${
                this.trans.tickets.table[
                    ticket.is_digital ? "is-digital" : "is-physical"
                ]
            }</h2>
            <p>${
                this.trans.tickets.table[
                    ticket.is_digital ? "is-digital-modal" : "is-physical-modal"
                ]
            }</p>
          `;
                    type = "description";
                    break;
            }

            this.modal.type = type;
            this.$root.toggleModal();
        },

        filterCallback(filters) {
            const [from, to] = filters.price.range;
            const datesKeys = Object.keys(filters.dates);
            const locationsKeys = Object.keys(filters.locations);
            const locationsSlugs = locationsKeys.map(
                key => filters.locations[key].slug
            );

            this.ticketsList = this.tickets.filter(ticket => {
                const pricesMatch = ticket.price >= from && ticket.price <= to;
                const datesDontMatch =
                    datesKeys.length > 0 &&
                    !datesKeys.includes((ticket.day - 1).toString());
                const locationsDontMatch =
                    locationsSlugs.length > 0 &&
                    !locationsSlugs.includes(ticket.slug);

                return pricesMatch && !datesDontMatch && !locationsDontMatch;
            });

            const scrollToSpacing = 30;
            const itemsList = document.querySelector(
                ".tickets-mobile-wrap .ticket-items"
            );
            const scrollUntil = itemsList.offsetTop - scrollToSpacing;

            window.scrollTo(0, scrollUntil);
        },

        possibleLocationFromURL() {
            const pathname = window.location.pathname;
            const pathnameList = pathname.split("/");
            return pathnameList[pathnameList.length - 1];
        },

        setLocationMatchesActive() {
            const possibleLocation = this.possibleLocationFromURL();

            return this.locations.map(location => {
                if (location.slug === possibleLocation) {
                    location.active = true;
                }
                return location;
            });
        },

        unobserve(obj) {
            return JSON.parse(JSON.stringify(obj));
        }
    }
};
</script>
